import Head from "next/head";
import Privacy from "../components/Privacy/[slug].js";

export default function privacy() {
  return (
    <>
      <Head>
        <title>Privacy Policy – NEET Support</title>
        <meta
          name="description"
          content="Review NEET Support's Privacy Policy to learn how we collect, use, and protect your personal information during NEET counseling services."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://neetsupport.com/privacy-policy"
        />
      </Head>
      <Privacy />
    </>
  );
}
